import * as Yup from 'common/yup';
import {enums} from 'types/enums';

export const AddOpenPGPSubKeyNames = {
   keyId: 'keyId',
   name: 'name',
   passphrase: 'passphrase',
   keyType: 'keyType',
   bitStrength: 'bitStrength',
   createTime: 'createTime',
   lifetime: 'lifetime',
   curveType: 'curveType',
} as const;

export const SubkeysExpirationNames = {
   keysCount: 'keysCount',
   keysDuration: 'keysDuration',
} as const;

export const addOpenPGPSubKeySchema = Yup.object({
   [AddOpenPGPSubKeyNames.keyId]: Yup.idString(),
   [AddOpenPGPSubKeyNames.name]: Yup.string(),
   [AddOpenPGPSubKeyNames.passphrase]: Yup.string().required(),
   [AddOpenPGPSubKeyNames.keyType]: Yup.string(), //.oneOf(PGPAlgorithm.keys),
   [AddOpenPGPSubKeyNames.bitStrength]: Yup.number().default(1024),
   [AddOpenPGPSubKeyNames.curveType]: Yup.string()
      .oneOf(enums.eccurveType.keys)
      .default(enums.eccurveType.enum.NISTP521),
   [AddOpenPGPSubKeyNames.createTime]: Yup.originDate().min(new Date()).default(new Date()),
   [AddOpenPGPSubKeyNames.lifetime]: Yup.number().default(0),

   [SubkeysExpirationNames.keysCount]: Yup.number().default(3),
   [SubkeysExpirationNames.keysDuration]: Yup.number().default(365),
});

export type IAddOpenPGPSubKey = Yup.InferType<typeof addOpenPGPSubKeySchema>;
